import React, { Component } from 'react';

type PagingProps = {
    currentPage: number,
    itemsPerPage: number,
    totalNumberOfItems: number,
    textOf: string,
    textPrevious: string,
    textNext: string,
    onPageChange: (page: number) => void,
}

type PagingState = {
}

export default class Paging extends Component<PagingProps, PagingState> {
    constructor(props: PagingProps) {
        super(props);
        this.state = {
        }
    }

    public goToPage(page: number) {
        this.props.onPageChange(page);
    }

    public render() {
        const startIndex = (this.props.itemsPerPage * (this.props.currentPage - 1)) + 1;
        let endIndex = startIndex + this.props.itemsPerPage - 1;
        endIndex = endIndex > this.props.totalNumberOfItems ? this.props.totalNumberOfItems : endIndex;

        return (
            <>
                {
                    this.props.totalNumberOfItems > 0 &&
                    <div className="row pb-10">
                        <div className="col">
                            <hr className="border-dark-ecru" />
                            <div className="d-flex justify-content-end">
                                <span className="text-large">
                                    <span className="font-weight-bold">
                                        {startIndex}

                                        {
                                            startIndex != this.props.totalNumberOfItems &&
                                            <span> - {endIndex}</span>
                                        }
                                    </span>
                                    <span> {this.props.textOf} {this.props.totalNumberOfItems}</span>
                                </span>

                                {
                                    startIndex > 1 &&
                                    <div className="d-flex align-items-center">
                                        <button type="button" onClick={() => this.goToPage(this.props.currentPage - 1)} className="btn p-0 ml-3 text-dark-blue text-large">
                                            <img className="mr-2" src="/img/svg/icon-chevron-left.svg" height="24" alt="" />
                                            {this.props.textPrevious}
                                        </button>
                                    </div>
                                }
                                {
                                    this.props.totalNumberOfItems > endIndex &&
                                    <div className="d-flex align-items-center">
                                        <button type="button" onClick={() => this.goToPage(this.props.currentPage + 1)} className="btn p-0 ml-3 text-dark-blue text-large">
                                            {this.props.textNext}
                                            <img className="ml-2" src="/img/svg/icon-chevron-right.svg" height="24" alt="" />
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }
}